import { useTranslation } from 'react-i18next'
import useMediaQuery from '@/hooks/use-media-query'
import { FilterBar, FilterTextWrapper } from '@/components/search-filter'
import { breakpoints } from '@/styles'
import TabMenu from './tab-menu'

const ExampleModalFilterBar = ({ currentTab, setCurrentTab }) => {
  const { t } = useTranslation()
  const displayMobile = useMediaQuery(`(max-width: ${breakpoints.ipadMiniMax})`)

  const menuItems = [
    {
      key: 'excellent',
      onClick: () => setCurrentTab('excellent'),
      isActive: currentTab === 'excellent',
      children: (
        <FilterTextWrapper>
          {t('l.trust_score.blockpay.example.filter.excellent', 'Excellent (90+)')}
        </FilterTextWrapper>
      )
    },
    {
      key: 'verygood',
      onClick: () => setCurrentTab('verygood'),
      isActive: currentTab === 'verygood',
      children: (
        <FilterTextWrapper multi>
          {t('l.trust_score.blockpay.example.filter.verygood', 'Very Good (75-89)')}
        </FilterTextWrapper>
      )
    },
    {
      key: 'average',
      onClick: () => setCurrentTab('average'),
      isActive: currentTab === 'average',
      children: (
        <FilterTextWrapper>
          {t('l.trust_score.blockpay.example.filter.average', 'Average (60-74)')}
        </FilterTextWrapper>
      )
    },
    {
      key: 'poor',
      onClick: () => setCurrentTab('poor'),
      isActive: currentTab === 'poor',
      children: (
        <FilterTextWrapper>
          {t('l.trust_score.blockpay.example.filter.poor', 'Poor (<60)')}
        </FilterTextWrapper>
      )
    }
  ]

  return (
    <FilterBar>
      <TabMenu
        options={menuItems}
        theme={displayMobile ? 'primary' : 'secondary'}
        size="medium"
        height={displayMobile && 44}
      />
    </FilterBar>
  )
}

export default ExampleModalFilterBar
